import type { FaireProductEntity } from "../../entity_types/product";

export const p_9sp5qave6g: FaireProductEntity = {
  token: "p_9sp5qave6g",
  type: "product",
  name: "Time to Read! With The Pigeon: 50 Bookplate Stickers",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/124c0750af04f14c3fc504db7da999fce73df2090c3f62ee406f7d8023b20f6a.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description: "Delight young readers with this charming pack of 50 bookplates featuring Mo Willems’ beloved character, the Pigeon! Perfect for personalizing classroom libraries, gifts, or home collections, each self-adhesive bookplate includes space for a name alongside playful illustrations that capture the humor and warmth of Willems’ award-winning character! Simply peel, place, and inscribe to add a special touch to any kid’s book. Use these bookplates on their own, or pair with the Pigeon Bookstop bookmarks or the From My Library! personal library kit. These charming kids’ bookplates feature a beloved Mo Willems character & support kids’ love of reading, collecting, and sharing books! Playful illustrations capture the humor and warmth of Willems’ award-winning Pigeon 4.5 x 6.5–inch portfolio; 50 adhesive bookplates in 5 different designs.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:09.860Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
